/*
 * @Author: your name
 * @Date: 2020-06-29 09:54:47
 * @LastEditTime: 2020-08-11 14:31:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-manage-web\src\router\index.js
 */ 
import Vue from 'vue';
import router from 'vue-router';
import Index from '@/components/Index/Index'
import Insurance from '@/components/insurance/insurance.vue';
import PayRecord from '@/components/payMent/payRecord/payRecord.vue';// 在线缴费
import PaySucceed from '@/components/payMent/paySucceed/paySucceed';
import SearchHint from '@/components/payMent/searchHint/searchHint';
import SearchResult from '@/components/payMent/searchResult/searchResult';
import InsuranceSucceed from '@/components/insurance/insuranceSucceed/insuranceSucceed';// 代办保险
import Warranty from '@/components/warranty/warranty.vue';// 在线报修
import WarrantyRecord from '@/components/warranty/warrantyRecord/warrantyRecord';
import WarrantyInfo from '@/components/warranty/warrantyInfo/warrantyInfo';
import Appointment from '@/components/appointment/appointment.vue';// 大厅预约
import AppointmentInfo from '@/components/appointment/appointmentInfo/appointmentInfo';
import BindingInfo from '@/components/bindingInfo/bindingInfo.vue';// 房屋绑定
import UserAgreement from '@/components/userAgreement/userAgreement.vue';//用户协议
import InsureSuccess from '@/components/insureSuccess/insureSuccess.vue';// 投保成功确认函
import ContinueStop from '@/components/continueStop/continueStop.vue';// 在线续停
import OwnerMessage from '@/components/continueStop/ownerMessage/ownerMessage.vue';// 房主信息
import Agreement from '@/components/continueStop/agreement/agreement.vue';// 停热协议
import CardCodeManage from '@/components/cardCodeManage/cardCodeManage.vue';// 卡号管理
import ContinueStopSucess from '@/components/continueStop/continueStopSuccess/continueStopSuccess.vue';// 续停成功
import HeatMetering from '@/components/heatMetering/heatMetering.vue';// 热计量公示

Vue.use(router);

export default new router({
    //mode: 'history',
    linkActiveClass: 'activeIndex',
    routes: [{
      path: '/',
      name: 'index',
      component: Index,
    },{
      path:'/insurance',
      name:'insurance',
      component:Insurance
    },{// 在线缴费
      path:'/payRecord',
      name:'payRecord',
      component:PayRecord
    },{
      path:'/paySucceed',
      name:'paySucceed',
      component:PaySucceed
    },{
      path:'/searchHint',
      name:'searchHint',
      component:SearchHint
    },{
      path:'/searchResult',
      name:'searchResult',
      component:SearchResult
    },{// 保险代办
      path:'/insuranceSucceed',
      name:'insuranceSucceed',
      component:InsuranceSucceed
    },
    {// 在线维修
      path:'/warranty',
      name:'warranty',
      component:Warranty
    },{
      path:'/warrantyRecord',
      name:'warrantyRecord',
      component:WarrantyRecord
    },{
      path:'/warrantyInfo',
      name:'warrantyInfo',
      component:WarrantyInfo
    },{// 大厅预约
      path:'/appointment',
      name:'appointment',
      component:Appointment
    },{
      path:'/appointmentInfo',
      name:'appointmentInfo',
      component:AppointmentInfo
    },{// 绑定信息
      path:'/bindingInfo',
      name:'bindingInfo',
      component:BindingInfo
    },{// 投保须知
      path:'/userAgreement',
      name:'userAgreement',
      component:UserAgreement
    },{
      path:'/insureSuccess',
      name:'insureSuccess',
      component:InsureSuccess
    },{//在线续停
      path:'/continueStop',
      name:'continueStop',
      component:ContinueStop
    },{//房主信息
      path:'/ownerMessage',
      name:'ownerMessage',
      component: OwnerMessage
    },{//在线续停协议
      path:'/agreement',
      name: 'agreement',
      component: Agreement
    },{//在线续停成功
      path:'/continueStopSuccess',
      name: 'continueStopSuccess',
      component: ContinueStopSucess
    },{//卡号管理
      path:'/cardCodeManage',
      name: 'cardCodeManage',
      component: CardCodeManage
      },
      {//卡号管理
        path:'/heatMetering',
        name: 'heatMetering',
        component: HeatMetering
      }
    
  ],
});